import script from "./recruitReviewedDetail.vue?vue&type=script&lang=ts&setup=true"
export * from "./recruitReviewedDetail.vue?vue&type=script&lang=ts&setup=true"

import "./recruitReviewedDetail.vue?vue&type=style&index=0&id=670ed3ce&lang=less"

const __exports__ = script;

export default __exports__